import { FC, memo, ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Box, Stack, Typography, useTheme } from "@mui/material";
import { APP_LOGO, APP_LOGO_SUBTITLE } from "consts";
import { STANDALONE_ARTICLE, STANDALONE_ARTICLE_ID } from "consts/url.consts";
import getStyles from "./styles";

type Props = {
  children: ReactNode;
};

const Sidebar: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <Box component="aside" sx={styles.container} className="RlxSidebar">
      <Stack component="figure" sx={styles.figure}>
        <Box component="a" href="/manage/portfolios">
          <Box component="img" src={APP_LOGO} alt="Company Logo" />
        </Box>
        <Box component="figcaption">{t(APP_LOGO_SUBTITLE || "")}</Box>
      </Stack>

      <Typography variant="h4" sx={styles.title}>
        ReluxStreetCalc
      </Typography>

      {STANDALONE_ARTICLE && (
        <Alert variant="outlined" severity="info" sx={styles.alert}>
          Running RSC on: <strong>{STANDALONE_ARTICLE}</strong>
          {STANDALONE_ARTICLE_ID}
        </Alert>
      )}

      {children}
    </Box>
  );
};

Sidebar.displayName = "Sidebar";

export default memo(Sidebar);
